import BenchmarkChip from '../BenchmarkChip';

import { BenchMarkScoreMetaData } from '../../../../shared/types/widget';
import { getLabelAndColor } from '../../../../utilities/common/utils';

interface ScoreBlockProps {
  scoreData: BenchMarkScoreMetaData;
  highlightScore?: boolean;
}

function ScoreBlock({ scoreData, highlightScore = false }: ScoreBlockProps) {
  const value = scoreData?.data?.value ?? 0;
  const scoreRanges = scoreData?.meta?.scoreRanges ?? [];

  const result = getLabelAndColor(value, scoreRanges);

  if (!result) return null;

  const { label, color } = result;

  return (
    <div className="flex items-center gap-x-2">
      <span
        className={`font-bold ${highlightScore ? 'text-4xl' : 'text-2xl'}`}
        style={{ color }}
      >
        {Math.round(value)}
      </span>
      <span className="text-grey-800 text-lg font-medium">/100</span>
      <BenchmarkChip label={label} color={color} />
    </div>
  );
}

export default ScoreBlock;
